import React from "react";

const InputText = ({ value, type = 'text', ...rest }) => {
  return <input value={value} {...rest} type={type} className="form-control text-center" />;
};

export default InputText;